import type { DeliveryRatingBreakdown } from '../../../domain';
import type { GiantId } from '../../../domain/ids/ids';

export type DeliveryResultScreenProps = {
  giantId?: GiantId;
  orderIndex?: number;
  rating?: DeliveryRatingBreakdown | null;
  onRestart?: () => void;
  onGoHome?: () => void;
  canRestart?: boolean;
  /** When false, the try-again button is not rendered. */
  showRestart?: boolean;
};

export type DeliveryResultScreenModel = {
  giantId?: GiantId;
  orderIndex: number;
  rating: DeliveryRatingBreakdown | null;
  onRestart?: () => void;
  onGoHome?: () => void;
  canRestart: boolean;
  showRestart: boolean;
};

export function createDeliveryResultScreenModel(
  props: DeliveryResultScreenProps,
): DeliveryResultScreenModel {
  return {
    giantId: props.giantId,
    orderIndex: props.orderIndex ?? 0,
    rating: props.rating ?? null,
    onRestart: props.onRestart,
    onGoHome: props.onGoHome,
    canRestart: props.canRestart !== false,
    showRestart: props.showRestart !== false,
  };
}
